const steps = [
  {
    number: '01',
    title: 'Cadastre-se como Parceiro',
    description: 'Crie sua conta em minutos e escolha o plano ideal para seu negócio. Sem burocracia, sem contratos longos.',
    icon: 'ri-user-add-line',
    details: ['Aprovação em até 24h', 'Sem taxa de adesão', 'Acesso ao Plano Free'],
  },
  {
    number: '02',
    title: 'Configure sua operação',
    description: 'Personalize os contratos e procurações que serão geradas. Cadastre seu cliente, faça upload dos arquivos e tenha controle total.',
    icon: 'ri-settings-3-line',
    details: ['Importação automática', 'Modelos personalizáveis', 'Suporte na configuração'],
  },
  {
    number: '03',
    title: 'Prospecte Novos Clientes',
    description: 'Use os editais enriquecidos para encontrar pessoas que precisam dos seus serviços e entre em contato.',
    icon: 'ri-search-eye-line',
    details: ['Leads qualificados', 'Filtros avançados', 'Exportação para WhatsApp'],
  },
  {
    number: '04',
    title: 'Automatize e Escale',
    description: 'Deixe a IA e a automação trabalharem por você. Gere recursos, documentos e relatórios automaticamente.',
    icon: 'ri-rocket-2-line',
    details: ['IA para recursos', 'Documentos automáticos', 'Relatórios em tempo real'],
  },
];

export default function HowItWorksSection() {
  return (
    <section className="py-12 md:py-24 relative overflow-hidden bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-48 md:w-96 h-48 md:h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-48 md:w-96 h-48 md:h-96 bg-yellow-500/10 rounded-full blur-3xl"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMiIvPjwvZz48L2c+PC9zdmc+')] opacity-50"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-20">
          <span className="inline-block px-3 md:px-4 py-1.5 md:py-2 bg-amber-500/20 text-amber-400 rounded-full text-xs md:text-sm font-semibold mb-3 md:mb-4 border border-amber-500/30">
            SIMPLES E RÁPIDO
          </span>
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">
            Como Funciona
          </h2>
          <p className="text-sm md:text-xl text-gray-400 max-w-3xl mx-auto">
            Em 4 passos simples você transforma sua operação
          </p>
        </div>

        {/* Steps Timeline */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-amber-500/50 to-transparent"></div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative group flex flex-col items-center">
                {/* Step Number Circle */}
                <div className="relative z-10 w-12 md:w-20 h-12 md:h-20 mb-4 md:mb-8 flex-shrink-0">
                  <div className="absolute inset-0 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-full blur-md opacity-50 group-hover:opacity-80 transition-opacity duration-300"></div>
                  <div className="relative w-full h-full bg-gradient-to-br from-amber-400 to-yellow-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300 border-2 border-amber-300/50">
                    <span className="text-base md:text-2xl font-bold text-gray-900">{step.number}</span>
                  </div>
                </div>

                {/* Content Card */}
                <div className="bg-gray-800/60 backdrop-blur-sm rounded-xl md:rounded-2xl p-4 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-700/50 w-full h-full group-hover:border-amber-500/30 group-hover:bg-gray-800/80 flex flex-col">
                  <div className="w-10 md:w-14 h-10 md:h-14 bg-gradient-to-br from-amber-500/20 to-yellow-500/20 rounded-lg md:rounded-xl flex items-center justify-center mb-3 md:mb-6 border border-amber-500/30 flex-shrink-0">
                    <i className={`${step.icon} text-amber-400 text-lg md:text-2xl`}></i>
                  </div>
                  
                  <h3 className="text-sm md:text-xl font-bold text-white mb-2 md:mb-3 min-h-[40px] md:min-h-[56px] flex items-start">{step.title}</h3>
                  <p className="text-xs md:text-base text-gray-400 mb-3 md:mb-6 leading-relaxed hidden md:block min-h-[72px] flex-grow">{step.description}</p>

                  <ul className="space-y-1 md:space-y-2 hidden md:block mt-auto">
                    {step.details.map((detail, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-xs md:text-sm text-gray-500">
                        <i className="ri-check-line text-amber-400 flex-shrink-0"></i>
                        <span className="text-gray-400">{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
